var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCheckboxUnchecked = function SvgCheckboxUnchecked(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#121619",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11V1C12 0.734784 11.8946 0.48043 11.7071 0.292893C11.5196 0.105357 11.2652 0 11 0V0ZM1 11V1H11V11H1Z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxUnchecked);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0iIzEyMTYxOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDBIMUMwLjczNDc4NCAwIDAuNDgwNDMgMC4xMDUzNTcgMC4yOTI4OTMgMC4yOTI4OTNDMC4xMDUzNTcgMC40ODA0MyAwIDAuNzM0Nzg0IDAgMVYxMUMwIDExLjI2NTIgMC4xMDUzNTcgMTEuNTE5NiAwLjI5Mjg5MyAxMS43MDcxQzAuNDgwNDMgMTEuODk0NiAwLjczNDc4NCAxMiAxIDEySDExQzExLjI2NTIgMTIgMTEuNTE5NiAxMS44OTQ2IDExLjcwNzEgMTEuNzA3MUMxMS44OTQ2IDExLjUxOTYgMTIgMTEuMjY1MiAxMiAxMVYxQzEyIDAuNzM0Nzg0IDExLjg5NDYgMC40ODA0MyAxMS43MDcxIDAuMjkyODkzQzExLjUxOTYgMC4xMDUzNTcgMTEuMjY1MiAwIDExIDBWMFpNMSAxMVYxSDExVjExSDFaIiAvPgo8L3N2Zz4K";